const isEmpty = require("is-empty");
const initialState = {
    isAuthenticated: false,
    news: {},
    loading: false
};
export default function(state = initialState, action) {
    switch (action.type) {

        case 'NEWS_ADD':
        return {
                isAuthenticated: !isEmpty(action.payload),
                news: action.payload
        };

        case 'NEWS_UPDATE':
            return {
                isAuthenticated: !isEmpty(action.payload),
                news: action.payload,
            };
        case 'SET_CURRENT_NEWS':
            return {
                ...state,
                isAuthenticated: !isEmpty(action.payload),
                news: action.payload
            };

        case 'NEWS_LOADING':
            return {
                ...state,
                loading: true
            };
        default:
            return state;
    }
}